var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"FBA配送单提示","close-on-click-modal":false,"visible":_vm.dialogVisible,"width":"580px","center":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"content"},[_vm._v(" 该配送单为FBA配送单，由FBA进行操作，请确认是否要继续操作 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }